const GenerateNodesAndEdges = (
  activeModeOrWindowWidth,
  safeRemainingHeightOrHeight = 588,
  BorderCondiction,
  height,
  appheaderheight,
  safeRemainingHeightArg
) => {
  const nodes = [];
  const edges = [];

  let activeMode = 'view';
  let safeRemainingHeight = 588;

  if (typeof activeModeOrWindowWidth === 'string') {
    activeMode = activeModeOrWindowWidth;
    safeRemainingHeight = Number(safeRemainingHeightOrHeight) || 588;
  } else {
    activeMode = BorderCondiction || 'view';
    safeRemainingHeight = Number(safeRemainingHeightArg || safeRemainingHeightOrHeight) || 588;
  }

  const rflight = typeof document !== 'undefined' ? document.querySelector('.app-header') : null;
  const rfWidth = rflight ? Math.max(1416, rflight.offsetWidth) : 1416;

  const totalRows = 7;
  const totalColumns = 11;
  const groupWidth = rfWidth / totalColumns;
  const groupHeight = safeRemainingHeight / totalRows - 0.3;

  const isEditor = activeMode === 'edit';

  for (let row = 0; row < totalRows; row++) {
    for (let col = 0; col < totalColumns; col++) {
      const xPos = col * groupWidth;
      const yPos = row * groupHeight;

      const colClass = `swimlane-col-${col}`;
      const rowClass = row === 0 ? 'showtopborder' : row === 6 ? 'hideborder' : '';
      const nodeClassName = `${colClass} ${rowClass}`.trim();

      nodes.push({
        id: `group-${row * totalColumns + col}`,
        row_id: `node_${row}_${col}`,
        type: 'group',
        data: { label: `Group ${row * totalColumns + col + 1}` },
        position: { x: xPos, y: yPos },
        draggable: false,
        className: nodeClassName,
        style: {
          width: groupWidth,
          height: groupHeight,
          borderTop: '0px',
          borderLeft: col === 0 || !isEditor ? '0px solid transparent' : '1px solid #E9EEF5',
          borderBottom: '0px solid #002060',
          borderRight: col === 0 ? '1px solid #1A192B' : '0px solid transparent',
          borderRadius: '0',
        },
      });
    }
  }

  return { nodes, edges };
};

export default GenerateNodesAndEdges;
